import setting from '@/setting.js'
import util from '@/utils/util'

export default {
  namespaced: true,
  state: {
    menus: [], //一级菜单
    submenus: [], //二级菜单
    collapse: setting.menuCollapse //侧边栏收缩状态
  },
  actions: {
    /**
     * 切换侧边栏展开和收缩状态
     */
    async toggle({ state }) {
      state.collapse = !state.collapse
      util.db.set('menu.collapse', state.collapse, true)
    },

    /**
     * 持久化数据加载侧边栏设置
     */
    async load({ state }) {
      state.collapse = util.db.get('menu.collapse', setting.menuCollapse, true)
    }
  },
  mutations: {
    /**
     * 设置一级菜单
     */
    setMenu(state, menus = []) {
      state.menus = menus
    },

    /**
     * 设置二级菜单
     */
    setSubmenu(state, menus = []) {
      state.submenus = menus
    }
  }
}
